import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { BadgeStateModel } from '../../models/badge/badge-model';
import {
  defaultSettingsForStandardChrono,
  getTableColumns,
} from './badge-settings.service';
import { SessionQuery } from '../session/session.query';
import { ChronoVersionEnum } from '../../models/client-models';

export interface BadgeState {
  data: BadgeStateModel;
  askForAbsence: boolean;
  settings: TableColumn[];
}

export const createInitialBadgeState = (sessionQuery: SessionQuery): BadgeState => {
  let settings: TableColumn[];
  if (sessionQuery.getChronoVersion() == ChronoVersionEnum.Standard) {
    settings = defaultSettingsForStandardChrono();
  } else {
    settings = getTableColumns();
  }
  return {
    data: {
      comeAndGo: undefined,
      dayInfo: undefined,
    },
    askForAbsence: false,
    settings,
  };
};

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'badge' })
export class BadgeStore extends Store<BadgeState> {
  constructor(private sessionQuery: SessionQuery) {
    super(createInitialBadgeState(sessionQuery));
  }
}
